import { render } from "./DeleteService.vue?vue&type=template&id=46f0bf94&ts=true"
import script from "./DeleteService.ts?vue&type=script&lang=ts&external"
export * from "./DeleteService.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__